<template>
	<div class="container page-mobile">

		<p>
			Oops...  :-(  Ainda não é possível utilizar a nossa plataforma através de dispositivos móveis, mas não se preocupe! Estamos trabalhando nisso. Uhuu ;-)
		</p>

	</div>
</template>
<style>

.page-mobile{
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 80px;
}
.page-mobile p{
	text-align: center;
	font-weight: bold;
	color:#0fbdc9;
	font-size: 20px;
}


</style>

<script>

	export default {

	};
</script>
